<template>
  <v-card>
    <v-card-title
      class="header headline green white--text justify-space-between">
      <div class="header">
        <v-icon @click="$emit('voltar')" class="icone white--text">mdi-arrow-left</v-icon>
        Amostragem</div>
      <v-icon large class="mx-1 my-1 icone white--text"> mdi-button-pointer</v-icon>
    </v-card-title>
    <div class="container">
        <v-form ref="form">
          <div class="d-flex justify-center contaainer">
              <core-date-time-picker-field
                hide-details
                form
                :key="formulario.dataamostra"
                :dense="false"
                v-model="formulario.dataamostra"
                :label="['Data', 'Hora']"
                :rules="rules.data"
              />
              <v-select
                label="Status"
                class="n-center"
                :items="status"
                icon="mdi-chevron-down"
                v-model="formulario.status"
                outlined
                :menu-props="{ bottom: true, offsetY: true }"
                :dense="!$_isMobile"
                :rules="rules.obrigatorio"
              >
              </v-select>
              <v-select
                label="Fluxo do Ar"
                class="n-center"
                :items="fluxoar"
                icon="mdi-chevron-down"
                v-model="formulario.fluxoar"
                outlined
                :menu-props="{ bottom: true, offsetY: true }"
                :dense="!$_isMobile"
                clearable
              >
              </v-select>
              <div class="d-flex">
                <v-text-field ref="umidadecima"
                :dense="true"
                outlined label="Cima (%)" class="textfield n-center" type="number"
                background-color="white"
                v-model="formulario.umidadecima"
                @keyup.enter="$refs.umidadecima.blur();"
                :rules="rules.umidadeFields">
                </v-text-field>
                <v-text-field ref="umidademeio"
                :dense="true"
                outlined label="Meio (%)" class="textfield n-center" type="number"
                background-color="white"
                v-model="formulario.umidademeio"
                @keyup.enter="$refs.umidademeio.blur();"
                :rules="rules.umidadeFields">
                </v-text-field>
                <v-text-field ref="umidadebaixo"
                :dense="true"
                outlined label="Baixo (%)" class="textfield n-center" type="number"
                background-color="white"
                v-model="formulario.umidadebaixo"
                @keyup.enter="$refs.umidadebaixo.blur();"
                :rules="rules.umidadeFields">
                </v-text-field>
              </div>
              <v-text-field ref="umidade"
                :dense="!$_isMobile"
                :rules="rules.umidade"
                outlined label="Média da Umidade (%)" class="textfield n-center" type="number"
                background-color="white" 
                v-model="formulario.umidade">
              </v-text-field>
              <v-textarea maxlength=100 height="4em" outlined counter v-model='formulario.observacao'
                background-color="white" label="Observação">
              </v-textarea>
              <div class="botoes">
                  <v-btn color="primary" class="mx-auto salvar" @click="$emit('voltar')">Voltar</v-btn>
                  <v-btn color="primary" class="mx-auto salvar" @click="$_checarUmidade">{{$$_textoBotao}}</v-btn>
              </div>
          </div>
        </v-form>
      <!-- <v-text-field></v-text-field> -->
      <br/>
    </div>
    
    <v-dialog v-model="dialogConfirm"  max-width="400px" width="80%">
      <v-card>
      <v-card-title class="header headline orange white--text justify-space-between">
        <div class="header">
          <v-icon @click="dialogConfirm = false" class="icone white--text">mdi-arrow-left</v-icon>
          Confirmar Umidade</div>
        <v-icon large class="mx-1 my-1 icone white--text"> mdi-warning-outline </v-icon>
      </v-card-title>
      <div class="mx-4 my-auto">
        <v-card-text class="font-weight-medium text-subtitle-1">
          A umidade desta amostra é maior que a amostra anterior ({{this.limiteUmidade}}%). Deseja prosseguir?
          </v-card-text>
        <div class="d-flex justify-space-between">
          <v-btn class="my-3" @click="dialogConfirm = false;">Voltar</v-btn>
          <v-btn color="green" class="my-3 white--text" @click="$_enviarAmostra">Continuar</v-btn>
        </div>
      </div>
      </v-card>
    </v-dialog>

  </v-card>
</template>

<script>
import CoreDateTimePickerField from '@/components/core/variant/date-time-picker-field variant/Index.vue'
//import CoreDateTimePickerField from '@/components/core/date-time-picker-field/Index.vue'
import geraData from '@/utils/geradata';
import errorHandler from '@/utils/error-handler';
import db from '@/plugins/dexie';
export default {
  name: 'CoredialogConfirm',

  components: {
    CoreDateTimePickerField,
  },

  props:{
    operacao: { type: Object },
    editarAmostra: { type: Object },
    dialogState: {type: Boolean}
  },
  
  computed: {
    $_isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    $$_operacao(){
      return this.$props.operacao;
    },
    $$_editarAmostra(){
      return this.$props.editarAmostra;
    },
    $$_textoBotao(){
      return this.atualizar ? 'Salvar' : 'Adicionar';
    },
    $$_mediaUmidade() {
      return this.formulario.umidadecima + this.formulario.umidademeio + this.formulario.umidadebaixo
    },
    $$_dialogState() {
      return this.$props.dialogState
    }

  },
  data() {
    return {
      atualizar: false,
      status: [
        'LIGADO', 'DESLIGADO'
      ],
      fluxoar: [
        'BPC', 'CPB'
      ],
      formulario: {
        dataamostra: geraData(),
        status: null,
        fluxoar: null,
        umidadecima: null,
        umidademeio:null,
        umidadebaixo: null,
        umidade: null,
        observacao: null,
      },
      
      dialogConfirm: null,
      limiteUmidade: null,

      rules: {
        obrigatorio: [ v => !!v || 'Este campo é obrigatório'],
        // não será utilizado
        /* fluxoar: [  
          v => {
            v
            if(!this.formulario.umidade && !this.$$_mediaUmidade && !this.formulario.fluxoar){
              return 'Este campo é obrigatório.'
            }
          }], */

          // provavelmente será utilizado
          /* umidade: [
            v => {
              v // só pra ignorar o erro
              if(!this.formulario.umidade && !this.$$_mediaUmidade && this.formulario.status !== 'DESLIGADO'){
                return 'É necessário pelo menos uma umidade.'
              }
            }
          ],
          umidadeFields: [
            v => {
              v // só pra ignorar o erro
              if(!this.formulario.umidade && !this.$$_mediaUmidade && this.formulario.status !== 'DESLIGADO'){
                return ''
              }
            }
          ] */
          data: [
            v => !!v || 'Data da amostra não pode ser vazia', 
            v => {
              v // só pra ignorar o erro
              if (this.formulario.dataamostra > geraData()) {
                return 'Data da amostra não pode ser maior que a atual'
              }
            },
            v => {
              if(v < geraData(this.limiteDataamostra, 'YYYY-MM-DD HH:mm')) {
                return `A data de amostra não deve ser menor que: ${geraData(this.limiteDataamostra, 'DD/MM/YY HH:mm')}.`
              }
            }
          ],
        }
    }
  },
  methods: {
    async $_enviarAmostra() {
      if (!this.$refs.form.validate()) {
        errorHandler('Amostra inválida.')
        return;
      }

      for (const [index, value] of Object.entries(this.formulario)) {
        if(value === null || value === '') {
          console.log(index)
          delete this.formulario[index]
        }
      }
      console.log('PROP OPERACAO', this.operacao)
      this.$emit('update', {
        tipo: 'amostra',
        operacao: this.operacao,
        id: this.$props.editarAmostra ? this.$props.editarAmostra.id : null,
        secid: this.$props.operacao.idsecador,
        ...this.formulario,
        })
      
      for (const index of Object.keys(this.formulario)) {
          if(index !== 'dataamostra') {
            this.formulario[index] = null
          }
        }
      this.atualizar = false;
      this.dialogConfirm = false;
    },

    async $_checarUmidade() {
      const umidCima = parseFloat(this.formulario.umidadecima) || 0;
      const umidMeio = parseFloat(this.formulario.umidademeio) || 0;
      const umidBaixo = parseFloat(this.formulario.umidadebaixo) || 0;
      if(parseFloat(this.formulario.umidade) > parseFloat(this.limiteUmidade) || (umidCima || umidMeio || umidBaixo) > this.limiteUmidade) {
        this.dialogConfirm = true;
      } else await this.$_enviarAmostra()
    }
  },
  watch: {
    $$_mediaUmidade: {
      handler() {
        if(!this.$$_editarAmostra) {
          const umidCima = parseFloat(this.formulario.umidadecima) || 0;
          const umidMeio = parseFloat(this.formulario.umidademeio) || 0;
          const umidBaixo = parseFloat(this.formulario.umidadebaixo) || 0;
          const count = [umidCima, umidMeio, umidBaixo].filter((umid) => umid !== 0);
          if(count.length > 1) {
            this.formulario.umidade = Math.round(((umidCima + umidMeio + umidBaixo )/count.length)*100)/100;
          }
        }
      }
    },
    $$_operacao: {
      deep:true,
      immediate:true,
      async handler() {
        this.limiteUmidade = null;
        this.limiteDataamostra = null;
        console.log('watcheramostra', this.$props.operacao)
        const amostras = await db.amostra.where({amodataoperacao: this.operacao.datainicio }).reverse().toArray();
        for (const amostra of amostras) {
          const {amoumidade, amoumidadebaixo, amoumidademeio, amoumidadecima} = amostra;
          const umidades = amoumidade || amoumidadebaixo || amoumidademeio || amoumidadecima || null;
          if (!this.limiteUmidade && umidades) {
            this.limiteUmidade = umidades;
          }
        }
        this.limiteDataamostra = amostras[0].amodataamostra;
        console.log('ULTIMADATA DE AMOSTRA', this.limiteUmidade, this.limiteDataamostra)
      }
    },
    $$_dialogState: {
      deep:true,

      handler() {
        if(!this.$props.dialogState) {
          console.log('dataamostra', this.formulario.dataamostra, geraData())
          this.$refs.form.resetValidation();
          this.formulario = {
            dataamostra: geraData(),
            status: null,
            fluxoar: null,
            umidadecima: null,
            umidademeio: null,
            umidadebaixo: null,
            umidade: null,
            observacao: null,
          }
        }
      }
    },
    $$_editarAmostra: {
      deep:true,
      handler() {
        if(this.$props.editarAmostra) {
          const item = this.$props.editarAmostra;
          this.$refs.form.resetValidation();
          console.log('amostra a ser editada', this.$props.editarAmostra, geraData(item.amodataamostra))
          this.formulario.dataamostra = geraData(this.$props.editarAmostra.amodataamostra);
          this.formulario = {
            dataamostra: geraData(item.amodataamostra),
            status: item?.amostatus,
            fluxoar: item?.amofluxoar,
            umidadecima: item?.amoumidadecima,
            umidademeio: item?.amoumidademeio,
            umidadebaixo: item?.amoumidadebaixo,
            umidade: parseInt(item?.amoumidade),
            observacao: item?.amoobservacao,
          }
          this.atualizar = true;
        } /* else {
          this.formulario = {
            dataamostra: geraData(),
            status: null,
            fluxoar: null,
            umidadecima: null,
            umidadebaixo: null,
            umidade: null,
            observacao: null,
          }
        } */
      }
    }
  }
}

</script>

<style scoped>
 .space {
    margin-bottom: 45px;
  }

  .center {
    width: 100%;
    text-align: center;
  }

  .card {
    padding: 3px;
    margin: 15px 10px 0px 10px
  }

  .card-secador {
    width: 90%;
    text-align: center;
    margin: 20px;
  }

  .linhas {
    height: 21%;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
  }

  .finalizado {
    background-color: #4CAF50;
  }

  .iniciado {
    background-color: #6b93ff;
  }

  .disponivel {
    background-color: #b9b9b9;
  }

  .digitavel {
    margin-bottom: 25px;
  }

    .linha-menor {
    height: 16%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 4px 0px 4px;
    font-size: 13px;
  }

  .inner-card {
    display: flex;
    justify-content: space-between;
    height: 67%;
  }

  .container-inner-items {
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .container-inner-items-fill {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .txt-center {
    text-align: center;
  }

  .input-container {
      width: 60%;
  }

  .container {
    width: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .contaainer {
    width: 93vw;
    max-width: 300px;
    flex-wrap: wrap;
  }

  .textfield {
    width: 90%;
  }

  .n-center >>> input {
      text-align: center;
  }

  .n-center >>> input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .nn-center >>> input {
      text-align: center;
  }

  .nn-center >>> input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .descricaoextra {
    color: #3d68de;
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    padding: 5px;
    background-color: #fdffd2;
  }

  .centerextra {
      flex: 1;
      text-align: center;
      font-size: 14px;
      font-weight: 500;
  }
  .card-lote-wrapper {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-inline: auto;
    max-width: 450px;
  }
  .card-lote {
    width: 100%;
  }
  
.botoes {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
</style>